package org.example.project.enginevertrieb

import androidx.compose.runtime.Composable

@Composable
fun VertriebsDashboard(node: String) {
    if (node == "SYS" && org.example.project.dashboard.ScreenManager.isLinkedInNode()) SysVertriebsDashboard(node)
    else VertriebBereichWrapper("VertriebsDashboard", node)
}
